import { toast } from '../primitives/toast.js';
/**
 * Одна на кит запись в буфер с тостом об исходе — общий низ `CopyButton` и
 * `CopyValue`. Возвращает `true` при успехе, чтобы вызывающий мог показать
 * своё подтверждение (галочку) только тогда, когда копирование состоялось.
 */
export async function copyToClipboard(value, successMessage, errorMessage) {
    try {
        await navigator.clipboard.writeText(value);
        toast.success(successMessage);
        return true;
    }
    catch {
        toast.error(errorMessage);
        return false;
    }
}
//# sourceMappingURL=copy-to-clipboard.js.map